<template>
  <BaseDrawer>
    <template
      #header>
      <div
        v-if="drawerMinimized"
        class="d-flex justify-content-center align-items-center pt-xs">
        <ConversationalSearchIcon
          width="32"
          height="32"/>
        <p class="ps-xs text-center text-white mb-0">
          Return to conversation
        </p>
      </div>
      <div
        v-else-if="!inIntro"
        class="header d-flex p-md align-items-center border-bottom-white text-white">
        <PlainButton
          class="p-0"
          @click.prevent.stop="goBackToIntro">
          <SvgChevronLeft color="white"/>
        </PlainButton>
        <ConversationalSearchIcon
          width="46"
          height="46"/>
        <div class="copy ms-sm">
          <h3 class="mb-xs">
            {{ greetingMessage }}
          </h3>
          <p class="mb-0">
            {{ greetingQuestion }}
          </p>
        </div>
        <PlainButton
          class="p-0 ms-auto align-self-start"
          @click.prevent.stop="handleDrawerClose">
          <SvgX color="white"/>
        </PlainButton>
      </div>
      <div
        v-else
        class="d-flex header">
        <PlainButton
          class="ms-auto mt-md me-md p-0"
          @click.prevent.stop="handleDrawerClose">
          <SvgX color="white"/>
        </PlainButton>
      </div>
    </template>
    <StylingChatbot/>
  </BaseDrawer>
</template>

<script setup>
import PlainButton from '@/components/global/sequin/PlainButton.vue'
import BaseDrawer from '@shared/components/ADORN/overlays/BaseDrawer.vue'
import StylingChatbot from '@/components/chatbot/StylingChatbot.vue'
import ConversationalSearchIcon from '@shared/components/icons/ConversationalSearchIcon.vue'
import SvgChevronLeft from '@/components/global/svg/SvgChevronLeft.vue'
import SvgX from '@/components/global/svg/SvgX.vue'
import { useStylingChatbotStore } from '@/stores/stylingChatbot.js'
import { useOverlaysStore } from '@/stores/overlays.js'
import { storeToRefs } from 'pinia'

function handleDrawerClose() {
  closeDrawer()
  allowScroll.value = true
}
const { drawerMinimized } = storeToRefs(useOverlaysStore())
const { closeDrawer } = useOverlaysStore()
const {
  greetingMessage,
  greetingQuestion,
  messageHistory,
  inIntro,
  messageHistoryNextPage,
  allowScroll
} = storeToRefs(useStylingChatbotStore())

const goBackToIntro = () => {
  inIntro.value = true
  messageHistory.value = []
  messageHistoryNextPage.value = null
}
</script>
<style scoped>
.open.header {
  height: 94px;
}

</style>